import React, { useRef, useState } from 'react';
import { VALIDATION_STATES } from '../../utils/constants';
import hasErrors from './hasErrors';
import runValidator from '../FieldValidation/runValidator';
const noop = () => undefined;
export default (function () {
  let {
    validators = [],
    onSubmit: submitHandler = noop,
    allowNativeSubmit = false
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const formEl = useRef(null);
  const [submitting, setSubmitting] = useState(false);
  const [validationState, setValidationState] = useState(VALIDATION_STATES.neutral);
  const [message, setMessage] = useState(null);
  const doValidation = async () => {
    setValidationState(VALIDATION_STATES.pending);

    // touch each form field and see if they have errors
    // if the fields do have errors, we'll error out here
    if (await hasErrors(formEl.current)) {
      setValidationState(VALIDATION_STATES.error);
      setMessage(null);
      return VALIDATION_STATES.error;
    }

    // if we made it passed field level validation, lets run through each validator at the form level
    const validationPromises = validators.map(validator => runValidator(validator));
    let validationState = VALIDATION_STATES.error;
    await Promise.all(validationPromises).then(messages => {
      messages = messages.filter(message => !message.valid);
      if (messages.length === 0) {
        validationState = VALIDATION_STATES.success;
        setValidationState(validationState);
        setMessage(null);
      } else {
        validationState = VALIDATION_STATES.error;
        setValidationState(validationState);
        const messageList = /*#__PURE__*/React.createElement("ul", null, messages.map(message => /*#__PURE__*/React.createElement("li", {
          key: JSON.stringify(message.message)
        }, message.message)));
        setMessage(messageList);
        return;
      }
    });
    return validationState;
  };
  const onSubmit = event => {
    event.preventDefault();
    if (submitHandler !== noop) {
      event.persist();
    }
    doValidation().then(validationState => {
      if (submitting) {
        return false;
      }
      setSubmitting(true);
      let doNativeSubmit = allowNativeSubmit;
      // submit only if we are valid
      if (validationState === VALIDATION_STATES.success) {
        if (submitHandler(event) === false) {
          doNativeSubmit = false;
        }
        if (doNativeSubmit) {
          HTMLFormElement.prototype.submit.call(formEl.current);
        }
      }
      setSubmitting(false);
    });
    return false;
  };
  return {
    validationState,
    message,
    doValidation,
    formProps: {
      ref: formEl,
      onSubmit
    }
  };
});